<template>
    <section class="hero">
        <div class="container pt-5">
            <div class="row">
                <div class="col-lg-12 text-center pt-3">
                    <div class="mt-5"><h2>¡Gracias por tu interés!</h2><br>
                        Lo que vas a adquirir no es solo un libro en preventa, es mucho más!<br>
                        Es una preparación integral para que los profesionales de salud puedan diferenciarse poderosamente de su competencia y posicionarse como experto a través de transformar su consulta al mundo digital con Telemedicina, usando un método probado, ético, legal y seguro, al precio de apenas 20 dolares!<br>
<br>
                        <h2>Te esperamos</h2></div><br>
                    <h1 >Pague de forma fácil y segura</h1>
                    <div><img src="/image/resource/libro.png" style="width: 150px"/></div>
                    <div class="col" style="border-bottom: solid 0.2px #F3F3F3; padding-bottom: 10px">
                        <div >Los pagos se procesan de forma segura cada mes con  <img src="https://cdn.paymentez.com/img/Logo2x.png" width="150px"/></div>
                    </div>
                    <div class="col" style="border-bottom: solid 0.2px #F3F3F3; padding-bottom: 10px; padding-top: 10px">
                        <div > Todo lo que necesitas hacer es agregar una tarjeta. Esto le permitirá disfrutar de todos los beneficios que en AMOBAMEDIC tenemos para ofrecer. No almacenamos en  nuestros servidores ningún dato sensible de su tarjeta.  Los pagos se realizan de forma segura a través de KushkiPagos.</div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="col-md-12 text-center pt-5 mb-3">


                <div class="">


                    <div style="height: 90vh; text-align: center; display: flex; flex-direction: row; justify-content: center">

                        <div v-if="!condition">
                            <h5 style="color:#5E72E4">Términos y condiciones</h5><br>
                            <div style="width: 100%; max-height: 90vh;overflow: auto; background: ivory">

                                <button class="btn btn-primary mt-2 mb-4" @click="condition = true">ACEPTO</button>
                                <button class="btn btn-dark mt-2 mb-4" @click="condition = false">NO ACEPTO</button>
                            </div>
                        </div>
                        <div v-else>

                            <div class="card">
                                <div style="width: 400px; padding: 5px; background-color: #eeeeee">
                                    <div style="float: right; color: white; font-size: 2rem; cursor: pointer; width: 20px; height: 20px" @click="condition = false">x</div>
                                    <form class="contact-form" >
                                        <div class="form-group">
                                            <input type="name" v-model="name" required class="form-control" id="name" placeholder="Nombre">
                                        </div>
                                        <div class="form-group">
                                            <input type="lname" v-model="last_name" required class="form-control"  placeholder="Apellido">
                                        </div>
                                        <div class="form-group">
                                            <input type="email" v-model="email" required class="form-control" id="email" placeholder="Email">
                                        </div>
                                        <div class="form-group">
                                            <vue-phone-number-input v-model="movil"
                                                                    :default-country-code="defaultCountry"
                                                                    :translations="translations"
                                                                    aria-required="true"
                                                                    size="lg"
                                                                    @update="onUpdate"
                                                                    v-validate="'required'"
                                                                    style="background-color: white" name="phone">
                                            </vue-phone-number-input>

                                        </div>
                                        <div class="col-md-12">
                                 <span class="text-left pb-2 recaptcha" v-if="!stateButton">
                                      <g-recaptcha @click.prevent="paymentezCheckout()"
                                                   :data-sitekey="sitekey"
                                                   :data-validate="validate"
                                                   :data-callback="callback"
                                                   data-btn-class="btn btn-primary btn-lg mb-3 mt-3 text-dark w-100 text-white"
                                                   data-language="es-419"
                                                   data-size
                                      >Continuar
                                        </g-recaptcha>
                                 </span>
                                            <div  class="btn disabled w-100 text-center" style="width: 160px;height: 50px; padding-left: 10%; background-color: grey; margin-top: 20px" disabled v-else>
                                                <half-circle-spinner
                                                        :animation-duration="600"
                                                        :size="25"
                                                        color="#ffffff"
                                                /> &nbsp;
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>

                        </div>

                    </div>
                    <!--compra aprobada-->
                    <transition name="modal" v-if="tranasction === true">
                        <div class="modal-mask">
                            <div class="modal-wrapper">
                                <div class="modal-container">



                                    <div class="modal-body">
                                       <p style="font-size: 1.5rem">Compra Aprobada</p>
                                        <img src="/image/resource/checkmark.gif"/>
                                        <p>Gracias por su compra... le estaremos contactando a la brevedad posible o contácnos a info@draomidresperez.com</p>
                                        <a class="btn btn-primary" href="https://www.facebook.com/groups/1040408526409829">CONTINUE AQUÍ</a>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </transition>
                    <!--end compra aprobada-->

                    <!--compra rechazada-->
                    <transition name="modal" v-if="tranasctionf === true">
                        <div class="modal-mask">
                            <div class="modal-wrapper">
                                <div class="modal-container">



                                    <div class="modal-body">
                                        <p style="font-size: 1.5rem">Compra Rechazada</p>
                                        <img src="/image/resource/failure.jpg" width="200px"/>
                                        <p>No se pudo procesar su compra, verifique su tarjeta e intente nuevamente,  más información escribanos a info@draomidresperez.com</p>
                                        <button class="btn btn-danger" @click="tranasctionf = false">
                                            OK
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </transition>
                    <!--end compra rechazada-->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import {mapState} from 'vuex'
    import axios from 'axios'
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import gRecaptcha from '@finpo/vue2-recaptcha-invisible';
    import toastr from 'toastr'
    import ar from 'vee-validate/dist/locale/ar';
    import {HalfCircleSpinner} from 'epic-spinners';

    export default {
        name: 'consulta_en_linea',
        components: {
            VuePhoneNumberInput,
            gRecaptcha,
            ar,
            HalfCircleSpinner,

        },
        data(){
            return {
                price: this.$route.params.price,
                token:this.$route.params.token,
                defaultCountry: 'EC',
                translations: {
                    countrySelectorLabel: 'Código',
                    countrySelectorError: 'Choisir un pays',
                    phoneNumberLabel: 'Numero de teléfono',
                    example: 'Exemple :'
                },
                movil: '',
                name:'',
                last_name:'',
                email:'',
                stateButton:'',
                sitekey:process.env.VUE_APP_RECAPTCHA,
                id: '',
                tranasction: false,
                tranasctionf: false,
                condition:false
            }
        },
        computed: {
            ...mapState,
                  },
        created(){
            this.idNumber();
        },
        methods:{
            checkUser: function () {

            },

            idNumber: function () {
                sessionStorage.setItem('id', Math.floor(Math.random() * 100))
                this.id = sessionStorage.getItem('id')
            },
            validate() {
                // validate your form , if you don't have validate prop , default validate pass .
                return true;
            },
            callback(token) {
                // google recaptcha token , then you can pass to backend with your form data .
                if (token) {
                    this.onSubmit();
                }else{
                    // if you use data-size show reCAPTCHA , maybe you will get empty token.
                    console.log('no eres un robot ')
                }
            },
            onSubmit() {

                this.$validator.validateAll().then((result) => {
                    this.$validator.localize('ar');

                    if (result) {
                        this.paymentezCheckout();
                    }

                });
            },
            onUpdate(payload) {
                this.results = payload.formatInternational

            },
            paymentezCheckout:function () {
                this.t_amount_t = Number(this.price);
                const self = this;
                const client = process.env.VUE_APP_PAYMENTEZ_CLIENT;
                const secret = process.env.VUE_APP_PAYMENTEZ_SECRET;
                const env = process.env.VUE_APP_PAYMENTEZ_ENVIRONMENT;
                this.stateButton = true;
                const email = this.email;
                const phone = this.movil;
                const user_id = this.id;
                const total_price = this.t_amount_t;

                const order_vat = parseFloat((total_price / 1.12) * 0.12).toFixed(2) ;

                const taxable_amount = parseFloat(total_price / 1.12).toFixed(2);

                const order_taxable_amount= Number(taxable_amount)


                var paymentezCheckout = new PaymentezCheckout.modal({
                    client_app_code: process.env.VUE_APP_PAYMENTEZ_CLIENT, // Client Credentials Provied by Paymentez
                    client_app_key: process.env.VUE_APP_PAYMENTEZ_SECRET, // Client Credentials Provied by Paymentez
                    locale: 'es', // User's preferred language (es, en, pt). English will be used by default.
                    env_mode: process.env.VUE_APP_ENVIROMENT, // `prod`, `stg` to change environment. Default is `stg`
                    onOpen: function() {
                        console.log('modal open');
                    },
                    onClose: function() {
                        console.log('modal closed');
                        self.stateButton = false;
                    },
                    onResponse: function(response) { // The callback to invoke when the Checkout process is completed

                        var transaction = response.transaction.status;

                        if (transaction === 'success'){

                            self.paymentSuccess(response)
                        }
                        else if (transaction === 'pending'){
                            self.paymentPending(response)

                        }
                        else if (transaction === 'failure'){
                            self.PaymentFailure(response)

                        }

                        console.log('modal response');

                    },

                });

                paymentezCheckout.open({
                    user_id: String(user_id),
                    user_email: email, //optional
                    user_phone: phone, //optional
                    order_description: 'Libro',
                    order_amount: total_price,
                    order_vat: Number(order_vat),
                    order_taxable_amount: Number(taxable_amount), // optional: Only available for Datafast (Equador). The taxable amount, if it is zero, it is calculated on the total. Format: Decimal with two fraction digits.
                    order_reference: '#234323411',
                    //order_installments_type: 2, // optional: For Colombia an Brazil to show installments should be 0, For Ecuador the valid values are: https://paymentez.github.io/api-doc/#payment-methods-cards-debit-with-token-installments-type
                    order_tax_percentage: 12 // optional: Only available for Datafast (Equador). The tax percentage to be applied to this order.
                });
                /*});*/

                // Close Checkout on page navigation:
                window.addEventListener('popstate', function() {
                    paymentezCheckout.close();
                });
            },


            paymentSuccess:function (responsex) {

                var url_tk = '/oauth/token';
                axios.post(url_tk, {
                    grant_type: 'client_credentials',
                    client_secret: process.env.VUE_APP_CLIENT_AP,
                   client_id: process.env.VUE_APP_CLIENT_ID
                }).then(response => {
                    var url2 = '/api/client/orderConsult/success';
                    this.at_token = response.data.access_token;
                    var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.at_token;

                    axios.post(url2, {
                        headers: {
                            token
                        },
                        name        : this.name,
                        last_name   : this.last_name,
                        email: this.email,
                        phone: this.movil,
                        transactional_id  : responsex.transaction.id,
                        authorization_code: responsex.transaction.authorization_code,
                        payment_method_id : '3',
                        note              : responsex.transaction.message,
                        status            : responsex.transaction.status,
                        data              : responsex,
                        amount            : responsex.transaction.amount,
                    }).then(response => {
                        if (response.data === 200){
                        toastr.success('Transacción Exitosa!');
                        this.name = '';
                        this.last_name = '';
                        this.phone = '';
                        this.email = '';
                        this.phone = '';
                        this.stateButton = false;
                        this.tranasction = true;
                        }
                    }).catch(err => {
                        this.stateButton = false;
                        toastr.error('ERROR inesperado, intente nuevamente o contactenos a soporte@amobamedic.com!');
                    });

                });
            },


            PaymentFailure: function (responsex) {
                var url_tk = '/oauth/token';
                console.log(process.env.VUE_APP_CLIENT_AP)
                axios.post(url_tk, {
                    grant_type: 'client_credentials',
                    client_secret: process.env.VUE_APP_CLIENT_AP,
                   client_id: VUE_APP_CLIENT_ID
                }).then(response => {
                    var url2 = '/api/client/orderConsult/failure';
                    this.at_token = response.data.access_token;
                    console.log(this.at_token)
                    var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.at_token;

                    axios.post(url2, {
                        headers: {
                            token
                        },
                        name        : this.name,
                        last_name   : this.last_name,
                        email: this.email,
                        phone: this.movil,
                        transactional_id  : responsex.transaction.id,
                        authorization_code: responsex.transaction.authorization_code,
                        payment_method_id : '3',
                        note              : responsex.transaction.message,
                        status            : responsex.transaction.status,
                        data              : responsex,
                        amount            : responsex.transaction.amount,
                    }).then(response => {
                        if (response.data === 401){
                            toastr.error('Transacción Rechazada!');
                            this.name = '';
                            this.last_name = '';
                            this.phone = '';
                            this.email = '';
                            this.phone = '';
                            this.stateButton = false;
                            this.tranasctionf = true;
                        }
                    }).catch(err => {
                        this.stateButton = false;
                        toastr.error('ERROR inesperado, intente nuevamente o contactenos a soporte@amobamedic.com!');
                    });

                });

            },

            paymentPending: function (response) {
                var url = '/api/v1/orderConsult/pending';
                var token = axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token');
                axios.post(url, {
                    headers: {
                        token
                    },
                    user_id           : user_id,
                    transactional_id  : response.transaction.id,
                    authorization_code: response.transaction.authorization_code,
                    payment_method_id : '2',
                    note              : response.transaction.message,
                    status            : response.transaction.status,
                    data              : response,
                    amount            : response.transaction.amount,
                    order_data        : response
                }).then(response => {
                    this.name = '';
                    this.last_name = '';
                    this.phone = '';
                    this.email = '';
                    this.phone = '';
                    this.stateButton = false;
                    this.tranasction = true;

                }).catch(err => {
                    this.stateButton = false;
                    toastr.error('ERROR inesperado, intente nuevamente o contactenos a soporte@amobamedic.com!');
                });
            },
        }
    }
</script>
<style scoped>

    .sub-title-service{
      padding: 30px; color: #343a40
    }

    .title-service{
        font-size: 3rem;
        padding-top: 20px;
        color: #191F4D
    }
    .box{
        display: flex;
        flex-direction: row;
        justify-content: center;
        padding-bottom: 300px
    }
    .box-datos{
        width: 50%;
        background-color:#1566AE;
        padding: 30px 60px
    }
    .side-info{
        width: 40%; padding: 20px; font-size: 1.2rem
    }



    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    .modal-container {
        width: 320px;
        margin: 0px auto;
        padding: 2px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 8px 0;
    }

    .modal-default-button {
        float: right;
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }



    @media (min-width: 1281px) {

    }

    @media (min-width: 1025px) and (max-width: 1280px) {

    }
    @media (min-width: 768px) and (max-width: 1024px) {

    }

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    @media (min-width: 481px) and (max-width: 767px) {
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-bottom: 300px
        }
        .box-datos{
            width: 100%;
            padding: 30px 10px
        }
        .side-info{
            width: 100%;
       padding:10px;
        }
    }

    @media (min-width: 10px) and (max-width: 480px) {

        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-bottom: 300px
        }
        .box-datos{
            width: 95%;
            padding: 30px 10px
        }
        .recaptcha{
            margin-left: 0;
        }
        .side-info{
            width: 95%;

        }
        .contenedor{

            grid-template-rows: 210vh;

        }
        .sub-title-service{
            padding: 0;
            width: 95%;
        }

        .title-service{
            font-size: 2rem;
            padding-top: 20px;
            color: #191F4D;
            width: 95%;
        }
    }
</style>
